import React from "react";
import "./App.css";
import { AppContextProvider } from "./contexts/AppContextProvider";
import { CallContextProvider } from "./contexts/CallContextProvider";
import { ConnectDataContextProvider } from "./contexts/DataContextProvider";
import CCPWrapper from "./components/CCPWrapper";
import { TokenContextProvider } from "./contexts/TokenContext";
import { RestApiContextProvider } from "./contexts/RestApiContext";

export function App() {
    return (
        <AppContextProvider>
            <CallContextProvider>
                <TokenContextProvider>
                    <RestApiContextProvider>
                        <ConnectDataContextProvider>
                            <CCPWrapper />
                        </ConnectDataContextProvider>
                    </RestApiContextProvider>
                </TokenContextProvider>
            </CallContextProvider>
        </AppContextProvider>
    );
}
